import React from 'react';
import { cn } from '../../../lib/utils';
import EditableDescriptionField from './EditableDescriptionField';

const TableDescription = ({
  summary,
  isFullScreen = false,
  compact = false,
  onUpdateMetadata,
  className,
}) => {
  const canEdit = isFullScreen && Boolean(onUpdateMetadata);

  if (!isFullScreen && !summary) return null;

  return (
    <div className={cn('shrink-0', className)}>
      {isFullScreen && (
        <h4
          className={cn(
            'font-black text-emerald-600 dark:text-emerald-400 uppercase tracking-[0.2em]',
            compact ? 'mb-1.5 text-xs' : 'mb-2 text-[11px] tracking-[0.3em]'
          )}
        >
          Table Description
        </h4>
      )}
      {isFullScreen && (
        <p
          className={cn(
            'leading-relaxed text-gray-600 dark:text-gray-300',
            compact ? 'mb-2.5 text-xs' : 'mb-3 text-sm'
          )}
        >
          Descriptions are auto-generated so the AI can understand your data. Click any field below to edit.
        </p>
      )}
      {canEdit ? (
        <EditableDescriptionField
          value={summary}
          onSave={(nextSummary) => onUpdateMetadata?.({ summary: nextSummary })}
          multiline
          compact={compact}
          emptyLabel="No description provided for this table yet."
          placeholder="Describe what this dataset is for..."
        />
      ) : (
        <p
          className={cn(
            'text-gray-600 dark:text-gray-400 font-medium leading-relaxed',
            compact || !isFullScreen ? 'text-xs' : 'text-sm'
          )}
        >
          {summary || 'No description provided for this table yet.'}
        </p>
      )}
    </div>
  );
};

export default TableDescription;
